<template>
  <div class="navbar" :class="{ expanded }">
    <div class="mobile-menu-btn" @click="expand">
      <transition>
        <div v-show="!expanded" class="icon-elems open">
          <div></div>
          <div></div>
          <div></div></div
      ></transition>
      <transition>
        <div v-show="expanded" class="icon-elems close">
          <div></div>
          <div></div>
        </div>
      </transition>
    </div>
    <!-- Desktop -->
    <transition>
      <div class="nav-menu" v-show="!isMobile">
        <ul>
          <li v-for="item in menuItems">
            <router-link
              :to="{ name: item.routeName }"
              exact-active-class="active"
              ><span>{{ item.label }}</span></router-link
            >
          </li>
        </ul>
      </div>
    </transition>
    <!-- Mobile -->
    <transition>
      <div
        class="nav-menu mobile"
        v-show="isMobile && expanded"
        :class="{ expanded }"
      >
        <ul>
          <li v-for="item in menuItems" @click="expand">
            <router-link
              :to="{ name: item.routeName }"
              exact-active-class="active"
              ><span>{{ item.label }}</span></router-link
            >
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';

@Component
class Navbar extends Vue {
  expanded = false;
  menuItems = [
    {
      routeName: 'main',
      label: 'Home'
    },
    {
      routeName: 'faqs',
      label: 'FAQs'
    },
    {
      routeName: 'contact',
      label: 'Contact'
    }
  ];

  get isMobile() {
    return this.$root.$data.isMobile;
  }

  @Watch('isMobile')
  onMobile(val) {
    if (!val && this.expanded) {
      this.expand();
    }
  }

  expand() {
    this.expanded = !this.expanded;
    this.$root.$data.scrollDisabled = this.expanded;
  }
}

export default Navbar;
</script>

<style lang="scss" scoped>
@import 'vars';

.navbar {
  display: flex;
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9999;

  > .mobile-menu-btn {
    display: none;
    opacity: 0;
    cursor: pointer;
    width: 60px;
    height: 60px;
    background: #0095ff;
    border-radius: 100%;
    position: absolute;
    width: 60px;
    height: 60px;
    top: 20px;
    left: 20px;
    box-shadow: 0 3px 8px #00000052;
    transform: scale(1);
    transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
    z-index: 1;
    border: 4px solid white;

    > .icon-elems {
      display: flex;
      position: absolute;
      width: 100%;
      height: 100%;

      justify-content: center;
      align-items: center;
      flex-direction: column;
      transform: scale(1);

      @include on-enter-start {
        transform: scale(0);
      }

      @include on-enter {
        transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
        transition-delay: 0.2s;
      }

      // @include on-leave-start {
      //   transform: scale(0);
      // }

      @include on-leave {
        transition: 0.15s;
      }

      @include on-leave-to {
        transform: scale(0);
      }

      > div {
        width: 35px;
        height: 5px;
        border-radius: 2px;
        display: inline-block;
        background: white;
        transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
      }

      &.open {
        > div {
          margin: 3px 0;
          transform-origin: 50%;

          &:nth-child(1) {
            //
          }

          &:nth-child(2) {
            //
          }

          &:nth-child(2) {
            //
          }
        }
      }

      &.close {
        > div {
          position: absolute;
          transform-origin: 50%;

          &:nth-child(1) {
            transform: rotateZ(45deg);
          }

          &:nth-child(2) {
            transform: rotateZ(-45deg);
          }
        }
      }

      > div {
        // width: 100%;
        // height: 100%;
      }

      > span {
        margin: 3px 0;
        width: 35px;
        height: 5px;
        border-radius: 2px;
        display: inline-block;
        background: white;
        transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);

        &:nth-child(1) {
          //
        }

        // &:nth-child(2) {
        //   transition-delay: 0.05s;
        // }
        //
        // &:nth-child(3) {
        //   transition-delay: 0.1s;
        // }
      }
    }

    @include mobile-mode {
      display: inline-block;
      opacity: 1;
    }

    @include hover {
      transform: scale(1.05);
      box-shadow: 0 15px 40px rgba(0, 55, 78, 0.2);
      background-image: linear-gradient(#fb7636, #ff5795) !important;

      > div {
        > span {
          width: 40px;
        }
      }
    }
  }

  > .nav-menu {
    width: 100%;
    max-width: 740px;
    margin: 0 auto;

    > ul {
      margin: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      list-style: none;
      padding: 0;
      background: #ffffff;
      border-bottom: 5px solid #83c4fd;
      box-shadow: 0 5px 30px #00000069;
      border-bottom-left-radius: 100px;
      border-bottom-right-radius: 100px;
      width: 100%;

      > li {
        > a {
          cursor: pointer;
          display: inline-block;
          padding: 0 20px;
          line-height: 80px;
          font-size: 24px;

          > span {
            display: inline-block;
            color: #0095ff;
            transform: scale(1);
            transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
          }

          &.active {
            > span {
              transform: scale(1.1) !important;
              color: #ff6200 !important;
            }
          }

          @include hover {
            > span {
              transform: scale(1.1);
              color: orange;
            }
          }
        }
      }
    }

    &.mobile {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      padding: 40px 40px 0;
      box-sizing: border-box;
      // background: #ffffffe8;
      background: linear-gradient(#4273ff, #aadcff);
      opacity: 1;
      max-width: none;

      @include on-enter-start {
        opacity: 0;

        > ul {
          transform: translateY(30px);
        }
      }

      @include on-enter {
        transition: 0.15s;

        > ul {
          transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
          // transition-delay: 10.2s;
        }
      }

      @include on-leave {
        transition: 0.15s;

        > ul {
          transition: 0.25s cubic-bezier(0.01, 0.85, 0.42, 1.73);
        }
      }

      @include on-leave-to {
        opacity: 0;

        > ul {
          transform: translateY(30px);
        }
      }

      // @include on-transition {
      //   opacity: 0;
      // }

      > ul {
        border-radius: 10px;
        flex-direction: column;
        transform: translateY(0);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue